import { forwardRef } from "react";
import { TableCell, TableRow } from "../../../../../components/ui/table";
import { Checkbox } from "../../../../../components/ui/checkbox";
import { Badge } from "../../../../../components/ui/badge";
import { OptroControlSummary } from "../../../../../models/audit/optroSync";

const EMPTY_VALUE = "–";

interface SelectControlRowProps {
  control: OptroControlSummary;
  checked: boolean;
  onToggle: (control: OptroControlSummary) => void;
}

// One selectable row of the import wizard's select-controls table. Takes a
// ref so the table can attach its infinite-scroll observer to the last row.
export const SelectControlRow = forwardRef<
  HTMLTableRowElement,
  SelectControlRowProps
>(({ control, checked, onToggle }, ref) => {
  const disabled = control.linked || control.importing;
  const badgeLabel = control.linked
    ? "Linked"
    : control.importing
      ? "Importing"
      : null;
  return (
    <TableRow
      ref={ref}
      className={disabled ? "opacity-50" : "cursor-pointer"}
      onClick={() => {
        if (!disabled) onToggle(control);
      }}
    >
      <TableCell onClick={(e) => e.stopPropagation()}>
        <Checkbox
          checked={checked}
          disabled={disabled}
          onCheckedChange={() => onToggle(control)}
          aria-label={`Select ${control.externalRef}`}
        />
      </TableCell>
      <TableCell className="font-medium">
        <div className="flex items-center gap-2">
          <span>
            {control.idCode ?? control.externalRef} - {control.name}
          </span>
          {badgeLabel && (
            <Badge variant="outline" className="whitespace-nowrap">
              {badgeLabel}
            </Badge>
          )}
        </div>
      </TableCell>
      <TableCell className="text-stone-600">
        {control.process ?? EMPTY_VALUE}
      </TableCell>
      <TableCell className="text-stone-600">
        {control.owner ?? EMPTY_VALUE}
      </TableCell>
      <TableCell className="text-stone-600">
        {control.frequency ?? EMPTY_VALUE}
      </TableCell>
    </TableRow>
  );
});

SelectControlRow.displayName = "SelectControlRow";
